import { render, staticRenderFns } from "./ProjectCreationDialog.vue?vue&type=template&id=01fbac85&scoped=true&"
import script from "./ProjectCreationDialog.vue?vue&type=script&lang=js&"
export * from "./ProjectCreationDialog.vue?vue&type=script&lang=js&"
import style0 from "./ProjectCreationDialog.vue?vue&type=style&index=0&id=01fbac85&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fbac85",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VContainer,VDialog,VFlex,VLayout,VTextField})
